import { Routes, Route, Navigate } from 'react-router-dom';
import { IS_DEV_BUILD } from '@/shared/config/flavor';
import DevLoginPage from '@/features/Auth/DevLoginPage';
import HomePage from '@/features/Home/HomePage';
import PublicNewsPage from '@/features/News/NewsPage';
import NewsDetailPage from '@/features/News/NewsDetailPage';
import NotFoundPage from '@/features/NotFound/NotFoundPage';
import { ConvitePage } from '@/features/Convite';
import { CadastroPage, VerifyPage, NovaSenhaPage } from '@/features/Cadastro';
import {
  DashboardLayout,
  DashboardPage,
  AccountPage,
  CharactersPage,
  RechargePage,
  CashShopPage,
  PremiumPage,
  SupportPage,
  RmtPage,
  MarketplacePage,
  StreamerCentralPage,
} from '@/features/Dashboard';
import {
  AdminLayout,
  AdminDashboardPage,
  AccountsPage,
  AccountDetailPage,
  CharactersPage as AdminCharactersPage,
  CharacterDetailPage,
  OnlinesPage,
  LogsPage,
  BannedsPage,
  GuardPage,
  NewsPage,
  MarketingPage,
  EventsPage,
  EventDetailPage,
  CashShopAdminPage,
  RechargesPage,
  ServicosPage,
  VendasPage,
  StreamersGmPage,
  PremiumPage as AdminPremiumPage,
  MonitorPage,
  GatewaysPage,
  AccessPage,
  TicketsPage,
  RmtPage as AdminRmtPage,
  ClientDownloadPage,
  ReferralsPage,
  GmToolsPage,
  GuildsPage,
  EmailsPage,
  BotsPage,
} from '@/features/Admin';

export const AppRouter = () => {
  // Build DEV (staff/outro host): SO login basico + painel GM. Todo o resto
  // (home, news, cadastro, dashboard do player) sai do bundle por tree-shaking.
  if (IS_DEV_BUILD) {
    return (
      <Routes>
        <Route path="/" element={<DevLoginPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="onlines" element={<OnlinesPage />} />
          <Route path="characters" element={<AdminCharactersPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="account/:userNum" element={<AccountDetailPage />} />
          <Route path="character/:idx" element={<CharacterDetailPage />} />
          <Route path="banneds" element={<BannedsPage />} />
          <Route path="guard" element={<GuardPage />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="marketing" element={<MarketingPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="events/:eventId" element={<EventDetailPage />} />
          <Route path="cashshop" element={<CashShopAdminPage />} />
          <Route path="recharges" element={<RechargesPage />} />
          <Route path="services" element={<ServicosPage />} />
          <Route path="sales" element={<VendasPage />} />
          <Route path="streamers" element={<StreamersGmPage />} />
          <Route path="premium" element={<AdminPremiumPage />} />
          <Route path="gamelog" element={<MonitorPage />} />
          <Route path="monitor" element={<MonitorPage />} />
          <Route path="gateways" element={<GatewaysPage />} />
          <Route path="access" element={<AccessPage />} />
          <Route path="rmt" element={<AdminRmtPage />} />
          <Route path="tickets" element={<TicketsPage />} />
          <Route path="client-download" element={<ClientDownloadPage />} />
          <Route path="referrals" element={<ReferralsPage />} />
          <Route path="gm-tools" element={<GmToolsPage />} />
          <Route path="guilds" element={<GuildsPage />} />
          <Route path="emails" element={<EmailsPage />} />
          <Route path="bots" element={<BotsPage />} />
          <Route path="bots/list" element={<BotsPage />} />
          <Route path="bots/:cid" element={<BotsPage />} />
        </Route>
        {/* Qualquer outra rota no dev volta pro login. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* Linkado pelo launcher (chama /News com N maiusculo). Lowercase tambem aceito. */}
      <Route path="/news" element={<PublicNewsPage />} />
      <Route path="/News" element={<PublicNewsPage />} />
      <Route path="/news/:id" element={<NewsDetailPage />} />
      <Route path="/News/:id" element={<NewsDetailPage />} />
      <Route path="/convite" element={<ConvitePage />} />
      <Route path="/cadastro" element={<CadastroPage />} />
      <Route path="/verify/:key" element={<VerifyPage />} />
      {/* Reset de senha — link do email aponta pra /password/<key> (RST_...) */}
      <Route path="/password/:key" element={<NovaSenhaPage />} />

      {/* Dashboard do USUÁRIO (player) */}
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="conta" element={<AccountPage />} />
        <Route path="personagens" element={<CharactersPage />} />
        <Route path="recarga" element={<RechargePage />} />
        <Route path="cashshop" element={<CashShopPage />} />
        <Route path="premium" element={<PremiumPage />} />
        <Route path="rmt" element={<RmtPage />} />
        <Route path="marketplace" element={<MarketplacePage />} />
        <Route path="suporte" element={<SupportPage />} />
        <Route path="streamer" element={<StreamerCentralPage />} />
      </Route>

      {/* Painel ADMIN — app paralela, layout próprio, GM gate */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboardPage />} />
        <Route path="onlines" element={<OnlinesPage />} />
        <Route path="characters" element={<AdminCharactersPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route path="account/:userNum" element={<AccountDetailPage />} />
        <Route path="character/:idx" element={<CharacterDetailPage />} />
        <Route path="banneds" element={<BannedsPage />} />
        <Route path="guard" element={<GuardPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="news" element={<NewsPage />} />
        <Route path="marketing" element={<MarketingPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="events/:eventId" element={<EventDetailPage />} />
        <Route path="cashshop" element={<CashShopAdminPage />} />
        <Route path="recharges" element={<RechargesPage />} />
        <Route path="services" element={<ServicosPage />} />
        <Route path="sales" element={<VendasPage />} />
        <Route path="streamers" element={<StreamersGmPage />} />
        <Route path="premium" element={<AdminPremiumPage />} />
        <Route path="gamelog" element={<MonitorPage />} />
        <Route path="monitor" element={<MonitorPage />} />{/* alias legado */}
        <Route path="gateways" element={<GatewaysPage />} />
        <Route path="access" element={<AccessPage />} />
        <Route path="rmt" element={<AdminRmtPage />} />
        <Route path="tickets" element={<TicketsPage />} />
        <Route path="client-download" element={<ClientDownloadPage />} />
        <Route path="referrals" element={<ReferralsPage />} />
        <Route path="gm-tools" element={<GmToolsPage />} />
        <Route path="guilds" element={<GuildsPage />} />
        <Route path="emails" element={<EmailsPage />} />
          <Route path="bots" element={<BotsPage />} />
          <Route path="bots/list" element={<BotsPage />} />
          <Route path="bots/:cid" element={<BotsPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
